export default __webpack_public_path__ + "static/media/wi-thermometer.68caee2f.svg";